import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageSEO from '@/components/base/PageSEO';
import { reviews } from '@/mocks/articles';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'AboutPage',
      name: '关于我们 - 51黑料网',
      description: '51黑料网品牌介绍、口碑评价与联系方式，全网热门黑料爆料与吃瓜事件汇总平台',
      url: 'http://3kyzh.com/about',
      isPartOf: {
        '@type': 'WebSite',
        name: '51黑料网',
        url: 'http://3kyzh.com/',
      },
    },
    {
      '@type': 'Organization',
      name: '51黑料网',
      url: 'http://3kyzh.com/',
      description: '全网热门黑料爆料与吃瓜事件汇总平台',
      email: 'tips@3kyzh.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: '北京市',
        addressRegion: '朝阳区',
        streetAddress: '望京SOHO T2',
      },
      sameAs: [
        'https://weibo.com/51heiliao',
        'https://weixin.qq.com/51heiliao',
      ],
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '51黑料网是什么？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '51黑料网是一个全网热门黑料爆料与吃瓜事件汇总平台，致力于为用户提供最新最全的娱乐资讯和八卦爆料信息。',
          },
        },
        {
          '@type': 'Question',
          name: '51黑料网的信息可靠吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '51黑料网采用AI智能抓取+人工编辑审核的双重机制，确保每一条信息的真实性和可信度，信息准确率达到99.7%。',
          },
        },
        {
          '@type': 'Question',
          name: '如何向51黑料网提供爆料线索？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '你可以通过我们的联系页面提交爆料线索，或直接发送邮件至tips@3kyzh.com，我们会对每一条线索进行认真核实。',
          },
        },
      ],
    },
  ],
};

export default function AboutPage() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    
    const honeypot = fd.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      setFormData({ name: '', email: '', message: '' });
      return;
    }

    setFormStatus('loading');
    try {
      const body = new URLSearchParams();
      body.append('name', formData.name);
      body.append('email', formData.email);
      body.append('message', formData.message);
      
      await fetch('https://readdy.ai/api/form/d9143gs6ci2plld1oieg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setFormStatus('success');
      setFormData({ name: '', email: '', message: '' });
    } catch {
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 3000);
    }
  };

  return (
    <>
      <PageSEO
        title="关于我们 - 51黑料网"
        description="了解51黑料网品牌故事、发展历程与核心团队，查看真实用户口碑评价，获取联系方式与合作渠道。全网最值得信赖的吃瓜信息聚合平台。"
        keywords="51黑料网,关于我们,黑料爆料,吃瓜平台,联系方式"
        canonical="http://3kyzh.com/about"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />
      <Navbar />
      <main className="pt-20 md:pt-24">
        {/* Hero */}
        <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto text-center">
            <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300 text-foreground-600 text-xs font-medium mb-6">
              关于我们
            </span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-6">
              51黑料网 — 全网最值得信赖的
              <br />
              吃瓜信息聚合平台
            </h1>
            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl mx-auto">
              我们致力于为每一位吃瓜群众提供最快、最全、最真实的娱乐资讯与黑料爆料，用专业的态度做最热门的八卦。
            </p>
          </div>
        </section>

        {/* Brand Story */}
        <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
              <div className="lg:w-[42%]">
                <div className="rounded-2xl overflow-hidden aspect-[4/3]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20creative%20team%20working%20in%20a%20bright%20open%20office%20space%2C%20collaborative%20workspace%20with%20warm%20lighting%2C%20people%20discussing%20around%20a%20wooden%20table%2C%20casual%20creative%20atmosphere%2C%20natural%20light%20from%20large%20windows%2C%20warm%20neutral%20tones%2C%20editorial%20photography%20style%2C%20no%20text%20no%20watermark&width=800&height=600&seq=about-brand-story&orientation=landscape"
                    alt="51黑料网团队"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="lg:w-[58%]">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
                  我们的故事
                </h2>
                <div className="space-y-4 text-foreground-600 leading-relaxed">
                  <p>
                    51黑料网诞生于2024年初，由一群深耕娱乐圈多年的资深媒体人和技术极客共同创立。在信息碎片化时代，我们发现吃瓜群众往往需要在多个平台之间来回切换，才能拼凑出一个完整的事件真相。
                  </p>
                  <p>
                    于是我们决定做一件事——打造一个一站式黑料爆料聚合平台。通过AI智能抓取+人工编辑审核的双重机制，我们能够在热点事件发生后的第一时间，为用户呈现最全面、最权威的信息汇总。
                  </p>
                  <p>
                    截至目前，51黑料网已经累计发布超过5000篇独家爆料内容，日均活跃用户突破百万，成为中文互联网最具影响力的吃瓜平台之一。但对我们来说，这仅仅是一个开始。
                  </p>
                </div>

                <div className="grid grid-cols-3 gap-6 mt-8">
                  {[
                    { value: '5000+', label: '独家爆料' },
                    { value: '100万+', label: '日活用户' },
                    { value: '99.7%', label: '信息准确率' },
                  ].map((stat) => (
                    <div key={stat.label} className="text-center">
                      <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500 mb-1">
                        {stat.value}
                      </div>
                      <div className="text-xs text-foreground-500">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Reviews */}
        <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <span className="text-xs tracking-widest uppercase text-foreground-400 font-medium">用户口碑</span>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mt-2">
                听听吃瓜群众怎么说
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
              {reviews.map((review) => (
                <div key={review.id} className="rounded-2xl p-6 md:p-7 bg-background-50 border border-background-200/70">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                      <img src={review.avatar} alt={review.name} className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">{review.name}</p>
                      <p className="text-xs text-foreground-500">{review.date}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-0.5 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className={`text-xs ${i < review.rating ? 'ri-star-fill text-secondary-500' : 'ri-star-line text-foreground-300'}`}></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    &ldquo;{review.content}&rdquo;
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
              <div className="lg:w-[45%]">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                  联系我们
                </h2>
                <p className="text-foreground-600 leading-relaxed mb-8">
                  如果你有独家爆料线索、商务合作需求，或者对我们的平台有任何建议，欢迎随时联系我们。我们会尽快回复你的消息。
                </p>

                <div className="space-y-5">
                  {[
                    { icon: 'ri-mail-line', label: '电子邮箱', value: 'tips@3kyzh.com' },
                    { icon: 'ri-wechat-line', label: '微信公众号', value: '51黑料网' },
                    { icon: 'ri-weibo-line', label: '官方微博', value: '@51黑料网官微' },
                    { icon: 'ri-map-pin-line', label: '办公地址', value: '北京市朝阳区望京SOHO T2' },
                  ].map((item) => (
                    <div key={item.label} className="flex items-start gap-4">
                      <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-background-50 text-foreground-600 flex-shrink-0">
                        <i className={`${item.icon} text-lg`}></i>
                      </span>
                      <div>
                        <p className="text-xs text-foreground-500 mb-0.5">{item.label}</p>
                        <p className="text-sm font-medium text-foreground-950">{item.value}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="lg:w-[55%]">
                <div className="rounded-2xl p-6 md:p-8 bg-background-50 border border-background-200/70">
                  <h3 className="text-lg font-heading font-bold text-foreground-950 mb-6">
                    发送消息
                  </h3>

                  {formStatus === 'success' ? (
                    <div className="py-8 text-center">
                      <span className="w-16 h-16 flex items-center justify-center rounded-full bg-accent-100 mx-auto mb-4">
                        <i className="ri-check-line text-2xl text-accent-600"></i>
                      </span>
                      <p className="text-foreground-950 font-semibold mb-2">消息已发送！</p>
                      <p className="text-sm text-foreground-500">我们会在24小时内回复你的消息</p>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-readdy-form="">
                      <div>
                        <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-700 mb-1.5">
                          你的名字
                        </label>
                        <input
                          id="contact-name"
                          type="text"
                          name="name"
                          required
                          value={formData.name}
                          onChange={(e) => setFormData((prev) => ({ ...prev, name: e.target.value }))}
                          disabled={formStatus === 'loading'}
                          className="w-full h-11 px-4 rounded-lg bg-background-100 border border-background-300/60 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                          placeholder="请输入你的名字"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-700 mb-1.5">
                          电子邮箱
                        </label>
                        <input
                          id="contact-email"
                          type="email"
                          name="email"
                          required
                          value={formData.email}
                          onChange={(e) => setFormData((prev) => ({ ...prev, email: e.target.value }))}
                          disabled={formStatus === 'loading'}
                          className="w-full h-11 px-4 rounded-lg bg-background-100 border border-background-300/60 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                          placeholder="请输入你的邮箱"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-700 mb-1.5">
                          留言内容
                        </label>
                        <textarea
                          id="contact-message"
                          name="message"
                          required
                          maxLength={500}
                          rows={5}
                          value={formData.message}
                          onChange={(e) => setFormData((prev) => ({ ...prev, message: e.target.value }))}
                          disabled={formStatus === 'loading'}
                          className="w-full px-4 py-3 rounded-lg bg-background-100 border border-background-300/60 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                          placeholder="请输入你的留言（最多500字）"
                        />
                        <p className="text-xs text-foreground-400 mt-1 text-right">{formData.message.length}/500</p>
                      </div>
                      <input
                        type="text"
                        name="phone_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0, width: 0 }}
                      />
                      <button
                        type="submit"
                        disabled={formStatus === 'loading'}
                        className="w-full h-11 rounded-lg bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors cursor-pointer disabled:opacity-60"
                      >
                        {formStatus === 'loading' ? '发送中...' : '发送消息'}
                      </button>
                    </form>
                  )}

                  {formStatus === 'error' && (
                    <p className="text-xs text-primary-600 mt-3 text-center">发送失败，请稍后重试</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
